<div class="modal single-table">
    <h3>Content Log</h3>
    <form [formGroup]="form" novalidate>
      <mat-form-field class="v-explicit-width">
        <mat-label>PDF File Name</mat-label>
        <input matInput formControlName="fileName" readonly>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Available Prints</mat-label>
        <input matInput formControlName="availablePrints" readonly>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Download Count</mat-label>
        <input matInput formControlName="downloadCount" readonly>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Open Count</mat-label>
        <input matInput formControlName="openCount" readonly>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Print Count</mat-label>
        <input matInput formControlName="printCount" readonly>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Transfer Count</mat-label>
        <input matInput formControlName="transferCount" readonly>
      </mat-form-field>
    </form>
    <table  #dataTable matSort (matSortChange)="sortData($event)" cellspacing="0" cellpadding="0">
      <thead>
      <tr>
        <th mat-sort-header="Operation">Operation</th>
        <th mat-sort-header="created_by">Added by</th>
        <th mat-sort-header="created_at">  Date &amp; Time</th>
        <th mat-sort-header="description"> Description</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let l of sortedData">
        <td>{{l.operation}}</td>
        <td>{{l.created_by}}</td>
        <td>{{l.created_at | date:'M/d/yyyy, h:mm a'}}</td>
        <td>{{l.description}}</td>
      </tr>
      </tbody>
    </table>
  </div>
  
  